<template>
    <footer>
        <div style="width: 100vw; background: #F1F3F466;">
            <div class="footer" style="display: flex; flex-direction: column; justify-content: space-between; max-width: 1180px; margin: 0 auto; height: 675px; padding-top: 162px; padding-bottom: 150px;">
                <div style="display: flex; align-items: flex-start;">
                    <div v-for="(item, index) in menu" :key="index">
                        <p style="display: inline-block; font-size: 16px; font-weight: 700; margin-bottom: 25px; margin-right: 168px;">{{item.title}}</p>
                        <div style="display: flex; flex-direction: column; color: #2C2C2C; font-size: 16px; font-weight: 400">
                            <div v-for="(value, count) in item.sub_title" :key="count" style="display: flex; margin-bottom: 25px">
                                <span v-if="(index == (menu.length - 1)) && (count == (item.sub_title.length - 1))" style="margin-right: 3px;">이메일:</span>
                                <p @click="(index == (menu.length - 1)) && (count == (item.sub_title.length - 1)) ? copy(value.text) : goPath(value.path)" class="footer_menu">
                                    {{value.text}}
                                    <span>
                                        <img v-if="(index == (menu.length - 1)) && (count == (item.sub_title.length - 1))" src="@/assets/images/icon/icon-copy.svg" alt="">
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display: flex; flex-direction: column;">
                    <p style="margin-bottom: 25px; color: #2C2C2C; font-weight: 700; font-size: 20px">(주)필드유</p>
                    <div style="display: flex; justify-content: space-between;">
                        <div style="display: flex; margin-bottom: 15px;">
                            <p @click="$router.push('/pages/login')" class="footer_text_bottom" style="margin-right: 44px;">대표 양지영</p>
                            <!-- <p class="footer_text_bottom" style="margin-right: 44px;">010-4788-8184</p> -->
                            <p class="footer_text_bottom">사업자 등록번호 442-81-01575</p>
                        </div>
                        <div style="display: flex">
                            <p @click="goPath('/pages/privacy-policy')" class="footer_menu footer_text_bottom_bold">채용 개인정보처리방침</p>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <p class="footer_text_bottom">경기도 안양시 동안구 시민대로 327번길 11-41, 5층 507호</p>
                        <p class="footer_text_bottom">Copyright © 2023 FilledU, All rights reserved</p>
                    </div>
                </div>
            </div>
        </div>
        <SnackBar v-if="showSnackBar" :info="snackbarInfo" @close="showSnackBar = false" />
    </footer>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar
    },
    data() {
        return {
            menu: [
                {
                    'title': '회사',
                    'sub_title': [
                        {
                            'text': '회사 소개',
                            'path': '/pages/introduction'
                        },{
                            'text': '제품 소개',
                            'path': '/pages/production'
                        },
                    ]
                },{
                    'title': '문의',
                    'sub_title': [
                        {
                            'text': '사업 제휴',
                            'path': '/pages/contact'
                        },{
                            'text': '광고 문의',
                            'path': '/pages/contact'
                        },{
                            'text': '마케팅･PR',
                            'path': '/pages/contact'
                        },
                    ]
                },{
                    'title': '고객센터',
                    'sub_title': [
                        {
                            'text': 'mesen@filledyou.com',
                            'path': ''
                        }
                    ]
                }
            ],
            showSnackBar: false,
            snackbarInfo: {
                text: '',
                icon: '',
                color: '',
                background: ''
            },
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
        copy(val) {
            navigator.clipboard.writeText(val).then(()=> {
                this.$store.commit('SET_SNACK_BAR_INFO' , {
                    text: '메일주소가 복사되었습니다.',
                    icon: 'icon-check.svg',
                    color: 'white',
                    background: '#1C9CD3'
                })
                this.showSnackBar = true
            })
        },
        goPath(val) {
            if(this.$route.path == val) {
                this.$router.go()
            } else {
                this.$router.push(val)
            }
        }
    }
    
}
</script>
<style>
    .footer .footer_menu:hover {
        text-decoration: underline;
        cursor: pointer;
    }
    .footer .footer_text_bottom {
        font-size: 16px;
        font-weight: 400;
    }
    .footer .footer_text_bottom_bold {
        font-weight: 500;
    }
</style>